import { ThemeProvider } from '@mui/material/styles';
import { Page } from '@unanet/ui';
import { WebComponentLocaleProvider } from '#/locale';
import { theme } from '#/theme';
import { TimeDashboardToggle } from './TimeDashboardToggle';
import type { TimeDashboardToggleWebComponentProps } from './models';

export const TimeDashboardToggleComponent = ({
  hideAndReset,
  personKey,
}: TimeDashboardToggleWebComponentProps) => (
  <ThemeProvider theme={theme}>
    <WebComponentLocaleProvider>
      <Page id={'toggle-page'} ignoreStyles>
        <TimeDashboardToggle
          hideAndReset={hideAndReset}
          personKey={personKey}
        />
      </Page>
    </WebComponentLocaleProvider>
  </ThemeProvider>
);
